import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { EditVendorCategorySlice } from '../../../../redux/features/VendorCategoryManagementSlice';
import ButtonSpinner from '../../../../common/Loader/ButtonSpinner';

const EditVendorCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const AnchorRef = useRef(null);
  const { loading } = useSelector((state) => state.VendorCategoryManagement);

  const [data, setData] = useState({
    categoryName: '',
    description: '',
    isActive: true,
  });

  useEffect(() => {
    setData({
      categoryName: state?.categoryName || '',
      description: state?.description || '',
      isActive: state?.isActive ?? true,
    });
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggle = () => {
    setData((prev) => ({ ...prev, isActive: !prev.isActive }));
  };

  const handleSubmit = () => {
    if (!data.categoryName?.trim()?.length) {
      toast.error('Please fill category name!');
      return;
    }

    dispatch(EditVendorCategorySlice({ id, data })).then((res) => {
      if (res?.payload?.data) {
        AnchorRef.current.click();
      }
    });
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <div className="ModalBox">
      <div id="EditVendorCategory" className="modal fade" role="dialog" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  ref={AnchorRef}
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  onClick={handleNavigate}
                >
                  ×
                </a>
                <h3>Edit Vendor Category</h3>
                <div className="form-group">
                  <label>Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="categoryName"
                    value={data.categoryName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    name="description"
                    value={data.description}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Category Status</label>
                  <div
                    onClick={handleToggle}
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                  >
                    <div
                      style={{
                        width: '50px',
                        height: '26px',
                        borderRadius: '20px',
                        backgroundColor: data.isActive ? '#28a745' : '#ccc',
                        position: 'relative',
                        transition: '0.3s',
                      }}
                    >
                      <div
                        style={{
                          width: '22px',
                          height: '22px',
                          borderRadius: '50%',
                          backgroundColor: '#fff',
                          position: 'absolute',
                          top: '2px',
                          left: data.isActive ? '26px' : '2px',
                          transition: '0.3s',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                        }}
                      />
                    </div>
                    <span>{data.isActive ? 'Active' : 'Inactive'}</span>
                  </div>
                </div>
                <button disabled={loading} onClick={handleSubmit} className="Button">
                  {loading ? <ButtonSpinner /> : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditVendorCategory;
